import Component from './component';

Component.defaultProps = {
    title: null,
    description: null,
    icon: null,
    children: null,
};
export default Component;
